





















































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import ListItem from '@/components/common/ListItem.vue'
import ServiceNewItemModal from './ServiceNewItemModal.vue'
import ServiceEditItemModal from './ServiceEditItemModal.vue'
import {Service, ServiceType, Location, Task} from '@/store/types'
import AppHeader from '@/components/common/AppHeader.vue'

@Component({
  components: {
    ListItem,
    ServiceNewItemModal,
    ServiceEditItemModal,
    AppHeader,
  },
})
export default class ServicesInfo extends Vue {
  @Getter('task') public task!: Task
  @Getter('services') public services!: Service[]
  @Getter('location') public location!: Location
  @Getter('availableServiceTypes') public availableServiceTypes!: ServiceType[]
  @Getter('showServiceNewItemModal') public showServiceNewItemModal!: boolean
  @Getter('showServiceEditItemModal') public showServiceEditItemModal!: boolean
  @Mutation('setServiceNewItemModal') public setServiceNewItemModal!: any
  @Mutation('setServiceEditItemModal') public setServiceEditItemModal!: any
  @Mutation('setActiveService') public setActiveService!: any
  @Mutation('setActiveServiceType') public setActiveServiceType!: any
  @Mutation('setLoader') public setLoader!: any
  @Action('addNewService') public addNewService!: any

  public addService(serviceType: ServiceType) {
    if (serviceType.class_name === 'Manual' ||
      serviceType.class_name === 'HeavyItemHandling' ||
      serviceType.class_name === 'Elevator' ||
      serviceType.class_name === 'Packing' ||
      serviceType.class_name === 'DebrisRemoval') {
      this.setLoader(true)
      const data: any = {
        additional_service_id: serviceType.id,
        lead_location_id: this.location.id,
        params: {amount: 0},
      }
      this.addNewService(data).then((response: Service) => {
        this.setLoader(false)
        this.setServiceNewItemModal(false)
      })
    } else {
      this.setActiveServiceType(serviceType)
      this.setServiceNewItemModal(true)
    }
  }

  public editService(service: Service) {
    // TODO update after service logic refactor
    if (!service.id && service.name !== 'Full Pack') {
      return
    }
    this.setActiveService(service)
    this.setServiceEditItemModal(true)
  }

  public serviceName(service: string) {
    return service.toLowerCase().split(' ').join('-')
  }
  public back() {
    this.$router.back()
  }
}
